<template>
  <div class="comWrap">
    <div class="comItemWrap" v-for="(item,index) in list" :key="index">
      <div class="comItemTiitle">{{item.title}}</div>
      <div class="comItemContent" v-html="item.content"></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [],
    data() {
      return {
        info: "",
        list:[
          {
            title:"指标因子",
            content:"扬尘因子：PM1.0、PM2.5、PM10、TSP、噪声等<br>" +
              "气象类型：微气象五参(风速、风向、温度、湿度、气压)、噪声<br>" +
              "AI智能识别算法：工地场地扬尘识别、工地出入口道路破损识别、渣土车未密闭运输识别、裸土未覆盖识别、车辆未清洗识别、工地物料乱堆放识别、工程车冒黑烟识别"
          },
          {
            title:"应用场景",
            content:"固定式、车载式、便携式手提箱、无人机机载"
          },
          {
            title:"方案内容",
            content:"建设基于多种感知技术、覆盖多种应用场景、多项数据融合，实时交互分析研判指挥治理的扬尘在线监测网络。<br>" +
              "实现秒级数据和米级范围监测采集，智能化数据分析 + 多证据耦合分析研判，精准判断扬尘污染事件特性，多级预警告警处理机制，做到精准溯源、全自动流程治理。最终达到有效解决扬尘污染、扬尘投诉、区域扬尘管控/指标质量提升的目的。"
          }
        ]
      }
    },
    created() {
    },
    components: {},
    methods: {}
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "~@/common/stylus/mixin.styl"
  .comWrap
    .comItemWrap
      margin-bottom 30px
      .comItemTiitle
        font-size 20px
        font-weight bold
        padding 15px 30px
        background-color #3E85F1
        border-radius 10px
        border 1px solid #072655
        display inline-block
        color white
      .comItemContent
        font-size 16px
        line-height 30px
        color #333
        margin-top 20px
</style>



// WEBPACK FOOTER //
// src/views/solution/components/com3.vue